<template>
  <div class="panel-container">
    <div class="header-container">
      <div class="title-container">
        <span class="title-text">现货收益统计</span>
        <span class="title-sub">实时价 / 日前价</span>
      </div>
      <div class="btns-container"></div>
    </div>
    <div class="main-container">
      <v-chart
        v-if="rows.length"
        :key="`spot-income-${rows.length}-${granularity}`"
        class="chart-container"
        :option="chartOption"
        :autoresize="true"
      />
      <div v-else class="empty-container">{{ loading ? '加载中…' : '暂无数据' }}</div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { getSpotIncomeChartOption } from './spotIncomeChartOptions.js'

defineOptions({ name: 'SpotIncomeChartPanel' })

const props = defineProps({
  rows: { type: Array, default: () => [] },
  granularity: { type: String, default: '15min' },
  loading: { type: Boolean, default: false },
})

const chartOption = computed(() => getSpotIncomeChartOption(props.rows, props.granularity))
</script>

<style lang="scss" scoped>
.panel-container {
  --header-height: 50px;

  & {
    width: 100%;
    height: 100%;
    background: transparent;
    padding: 20px;
    display: flex;
    flex-direction: column;
  }

  .header-container {
    width: 100%;
    height: var(--header-height);
    min-height: var(--header-height);
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .title-container {
      flex: 1;
      display: flex;
      align-items: baseline;
      gap: 8px;

      .title-text {
        color: #2e2e2e;
        font-family: 'HarmonyOS Sans SC';
        font-size: 16px;
      }

      .title-sub {
        color: #999;
        font-family: 'HarmonyOS Sans SC';
        font-size: 12px;
      }
    }

    .btns-container {
      flex-shrink: 0;
      display: flex;
      align-items: center;
    }
  }

  .main-container {
    width: 100%;
    height: calc(100% - var(--header-height) - 16px);
    box-sizing: border-box;
    flex: 1;
    display: flex;
    flex-direction: column;

    .chart-container {
      width: 100%;
      height: 100%;
      flex: 1;
    }

    .empty-container {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #999;
      font-family: 'HarmonyOS Sans SC';
      font-size: 14px;
    }
  }
}

::v-deep .chart-tooltip {
  padding: 12px 16px !important;
  border-radius: 8px !important;
}

::v-deep .chart-tooltip__time {
  margin-bottom: 8px;
  font-family: 'HarmonyOS Sans SC';
  font-size: 14px;
}

::v-deep .chart-tooltip__items-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

::v-deep .chart-tooltip__series {
  display: flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 6px;
}

::v-deep .chart-tooltip__point {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 6px;
}

::v-deep .chart-tooltip__series-name {
  font-family: 'HarmonyOS Sans SC';
  font-size: 13px;
  margin-right: 8px;
}

::v-deep .chart-tooltip__value {
  font-family: 'HarmonyOS Sans SC';
  font-size: 14px;
  font-weight: 600;
}

::v-deep .chart-tooltip__warn {
  margin-top: 8px;
  color: #e6a23c;
  font-family: 'HarmonyOS Sans SC';
  font-size: 12px;
}
</style>
